import React, { Component } from 'react'
import Web3 from 'web3'
import Box1_0 from '../Box1_0/Box1_0';
import Ticket1_0 from '../Ticket1_0/Ticket1_0';
import PriceList1_0 from '../Ticket1_0/PriceList1_0'
import PairPriceList1_0 from '../PairSwapper1_0/PairPriceList1_0'
import FreebiesList1_0 from '../Freebies1_0/FreebiesList1_0'
import BoxesInstallerManager from '../BoxesInstallerManager/BoxesInstallerManager';
import './css.css';



class SingleUserBook extends Component {
constructor(props){
    super()
    this.loadModules = this.loadModules.bind(this)
this.state={enabled_items:[],edit: false}
this.renderAgain = this.renderAgain.bind(this);
this.setAmountItems = this.setAmountItems.bind(this);
}



renderAgain(){
    this.loadModules()
    this.render()
}



    componentDidMount(){
      this.loadModules()
    }

    async setAmountItems(i){
      
    }


async loadModules(){
    let total_modules=[]
    let rendAgain=() => this.renderAgain
    let showBoxx=this.showBox
    console.log("singleuserbook ENTER");
    let edit=this.props.edit
    let setamountnull=() => this.setAmountItems(0)
    await window.ethereum.enable().then(async function (accounts) {   
        const { REACT_APP_OWNERSHIPABI } = process.env;
        const { REACT_APP_OWNERSHIP } = process.env;
        const ownsership = new web3.eth.Contract(JSON.parse(REACT_APP_OWNERSHIPABI), REACT_APP_OWNERSHIP) 
        console.log(await ownsership.methods.owned(accounts[0],0).call());   
        let owned=await ownsership.methods.owned(accounts[0],0).call()
        console.log("singleuserbook COUNT"+owned[1]);
        for(let i=0;i<owned[1];i++){
            let addr
            addr=await ownsership.methods.owned(accounts[0],i).call()
            console.log("-----------------------------------------------")
            console.log("singleuserbook MODULE ADDRESS: "+addr[0])
            const { REACT_APP_HAPPYBOXABI } = process.env;
            const happybox = new web3.eth.Contract(JSON.parse(REACT_APP_HAPPYBOXABI), addr[0]) 
            let count=0;
            for(let j=0;j<count+1;j++){
                let addr
                let found=false
                try{
                addr=await happybox.methods.modules_list(j).call()
                console.log("singleuserbook modules_list> ",addr)
                    found=true
                    count++
                }catch(e){ console.log("ERROR singleuserbook modules_list",e)}  
                if(found){ 
                    let code=0  
                    try{
                        const { REACT_APP_TICKETABI } = process.env;
                      
                    let module = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), addr)
                    let codex=await module.methods.code().call()
                    code=codex
                    }catch(f){ console.log("singleuserbook codex",f)} 
                    let enabled=await happybox.methods.modules(addr).call()
                    if(enabled){
                        console.log("singleuserbook MODULE ADDRESS: "+addr)
                        document.getElementById("UserBook_access_point_count").innerHTML='📦 '+(i+1)+'  🏪 '+(total_modules.length+1)
                      if(code==4)total_modules.push(<PriceList1_0 edit={edit} address={addr} key={total_modules.length+1} index={total_modules.length+1} setAmount={() => setamountnull()}></PriceList1_0>)
                      if(code==7)total_modules.push(<FreebiesList1_0 edit={edit} address={addr} key={total_modules.length+1} index={total_modules.length+1} setAmount={() => setamountnull()}></FreebiesList1_0>)
                      if(code==9)total_modules.push(<PairPriceList1_0 edit={edit} address={addr} key={total_modules.length+1} index={total_modules.length+1} setAmount={() => setamountnull()}></PairPriceList1_0>)
                       
                    }      
                }  
            }             
        }     
    })
    this.setState({enabled_items : total_modules,edit:this.props.edit})
    this.render()
}

    render(props){

    if(this.state.edit!=this.props.edit)this.loadModules()
        return ( <>
        <div id="UserBook_access_point_count" className="UserBook_mainlabel left">📦 0  🏪 0 access points</div> 
            <div className="UserBook_mainlabel right"> blue book 📘 </div> 
        

<div className="clear"></div> 
<div className="UserBook_Container light lightblue"> 
                {
                  this.state.enabled_items  
                }      
      </div>
            </>
        );
    }


}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

        
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")




export default SingleUserBook